Ext.define('SA.data.DatasetAbbreviations', {
    singleton: true,

    all: {
        HCEN1980: 'hist', 
        HCEN1990: 'hist', 
        HCEN2000: 'hist', 
        HCEN2010: 'hist', 

        NAICS: 'easi',
        CENSUS: 'easi',
        CONEXP: 'easi',
        HEALTH: 'easi',
        LFSTG: 'easi',
        MRI: 'easi',
        OTHR: 'easi',
        PROF: 'easi',
        RET: 'easi',

        AGSUP00: 'ags',
        AGSUP10: 'ags',
        AGSCEN80: 'ags',
        AGSCEN90: 'ags',
        AGSCEN2000: 'ags',
        AGSCEN: 'ags',
        AGSHEALTH: 'ags',

        UCR: 'ucr',

        CONNX: 'connexions',
        CNBYPW: 'cbp',
        FINCLT: 'fin clout',
        INSCLT: 'ins clout',
        PRZMPUS: 'prizm',
        PSYCLEP: 'p$ycle',
        RTMKPW: 'rmp',

        SMN: 'simmons',

        SCRBGH: 'scarborough',

        USDEC2000: 'cen 2000',
        USDEC2010: 'cen 2010',
        USDEC2020: 'cen 2020',
        USACS: 'acs',
        USACSSUB: 'dem',
        USCBP: 'cbp',
        USCBPSUM: 'cbp',

        USELEC: 'elec',
        USELECDL: 'elec',

        USBEA: 'bea',

        USNOAA: 'noaa',

        USCEX: 'cex',

        PLHD: 'places', 
        SACL: 'cls', 

        ABI: 'ageincome',        
        ADJCEN01: 'cen 2001',    
        ADJCEN06: 'cen 2006',    
        ADJCEN11: 'cen 2011',    
        ADJCEN16: 'cen 2016',    
        ADJCEN21: 'cen 2021',    
        CACCHSG2: 'health',      
        CAPRIZMG4: 'prizm',      
        CAPRIZMG4AB: 'prizm ab', 
        CAPRIZMG4BC: 'prizm bc', 
        CAPRIZMG4ON: 'prizm on', 
        CCHS: 'cchs',            
        COVID19CA: 'covid19',    
        DAYPOP: 'daypop',        
        DEMEST: 'demostats',     
        DEMESTTR: 'demotrends',  
        DGTLS: 'digital',        
        DGTLSBC: 'digitalbc',    
        FSPND: 'foodspend',      
        HSPND: 'hhspend',        
        OPTCARE: 'optcare',      
        PRZM5CA: 'prizm5',       
        PRZM5ABCA: 'prizm5ab',   
        PRZM5BCCA: 'prizm5bc',   
        PRZM5ONCA: 'prizm5on'    
    }
});